// extracted by mini-css-extract-plugin
module.exports = {"section":"label-partners-module--section--3q1RR","header":"label-partners-module--header--28vGS","link":"label-partners-module--link--1tWF5"};